import script from "./ShoppingCartFloating.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShoppingCartFloating.vue?vue&type=script&setup=true&lang=ts"

import "./ShoppingCartFloating.vue?vue&type=style&index=0&id=17a87dd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a87dd3"]])

export default __exports__